import BackendService from './BackendService';

export default class DealService {
  static getShowroomList(startDate, endDate) {
    const params = {
      since: startDate,
      until: endDate,
    };
    return BackendService.get('/deals/showroomList', { params });
  }

  static getOnlineList(startDate, endDate) {
    const params = {
      since: startDate,
      until: endDate,
    };
    return BackendService.get('/deals/onlineList', { params });
  }

  static exportDeals(searchParams) {
    const params = {
      search: searchParams,
      type: 'blob',
    };
    return BackendService.get('/deals/csv', { params });
  }

  static getAllDeals(page, perPage, searchParams, sortParams) {
    const params = {
      page,
      perPage,
      search: searchParams,
    };
    if (sortParams && sortParams.name) {
      params.sortName = sortParams.name;
    }
    if (sortParams && sortParams.order) {
      params.sortOrder = sortParams.order;
    }
    return BackendService.get('/deals/all', { params });
  }

  static getDeal(dealId) {
    return BackendService.get(`/deals/${dealId}`);
  }

  static createDeal(body) {
    return BackendService.post('/deals', { body });
  }

  static createOnlineDeal(dealerId, body) {
    return BackendService.postWithoutToken('/deals', dealerId, { body });
  }
}
